import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { useAppContext } from 'Context/ReactAppContext';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { Icon } from 'Components/frameworks/icon/Icon';
type Props = {
  className: string;
  isActive?: boolean;
  isAuthenticated?: boolean;
  isQuickLoggedIn?: boolean;
  onClick?: () => void;
  size?: number;
  title: string;
};
export const NavigationMemberAccessButton = ({
  className,
  isActive,
  isAuthenticated,
  isQuickLoggedIn,
  onClick,
  size = 1.5,
  title,
}: Props) => {
  const appContext = useAppContext();
  const { trackClickEvent } = useTrackEvent();

  if (isFeatureFlipped(appContext)('memberSpace.hideConnectionButton')) {
    return null;
  }

  const isAnimationEnable =
    !isFeatureFlipped(appContext)('memberSpace.disableConnectionAnimation') && !isAuthenticated;
  return (
    <button
      aria-expanded={isActive}
      className={className}
      onClick={() => {
        onClick?.();

        if (!isActive) {
          trackClickEvent(TRACK_EVENT_NAMES.CLICK_HEADER, {
            detail_click: 'my_account',
          });
        }
      }}
      title={title}
      type="button"
    >
      <span className="relative flex" data-testid="user-icon">
        {!!title && <span className="sr-only">{title}</span>}
        <Icon name={ICONS.PEOPLE} width={`${size}rem`} />
        {(isAuthenticated || isQuickLoggedIn) && (
          <span
            className={classnames(
              'absolute right-[-0.3125rem] top-[-0.5625rem] flex size-12 items-center justify-center rounded-full leading-0',
              {
                'bg-green': isAuthenticated,
              },
            )}
          >
            <Icon className="text-white" name={ICONS.CHECK} width="0.5rem" />
          </span>
        )}
        {isAnimationEnable && (
          <span
            className="absolute animate-hello"
            style={{
              top: `${size * 0.153}rem`,
              left: `${-size * 0.38}rem`,
              width: `${size * 0.6}rem`,
              height: `${size * 0.6}rem`,
              border: `solid ${size * 0.08}rem black`,
              borderRadius: '0 0 50% 80%',
              borderColor: 'transparent transparent currentColor transparent',
              transformOrigin: 'bottom right',
            }}
          />
        )}
      </span>
    </button>
  );
};
